

export default `
    mutation ($input: inputAutomationConnection!) {
        createAutomationConnection(input: $input) {
            accountId
        }
    }
`;
